import { currencyCodeCookieKey } from "~/constants/cookieKeys";
import type { Currency } from "~/types/Finance";

export default function useActiveCurrency() {
  const platformStore = usePlatformStore();
  const availableCurrencies = computed(
    () => platformStore.getPlatformConfiguration.properties.availableCurrencies,
  );

  const currencyCodeCookie = useCookie<string>(currencyCodeCookieKey, {
    maxAge: 60 * 60 * 24 * 365, // 1 year
  });

  const { $segment } = useNuxtApp();
  const setActiveCurrency = (isoCurrencyCode: string) => {
    currencyCodeCookie.value = isoCurrencyCode;

    $segment.browser.value.identify({
      selected_currency: isoCurrencyCode,
    });
  };

  const activeCurrency = computed<Currency>(() => {
    const currencyCode = currencyCodeCookie.value;

    return (
      availableCurrencies.value.find(
        (currency) => currency.isoCurrencyCode === currencyCode,
      ) ??
      platformStore.getPlatformConfiguration.properties.defaultCurrency ?? {
        name: "Euro",
        isoCurrencyCode: "EUR",
        symbol: "€",
      }
    );
  });

  return {
    activeCurrency,
    setActiveCurrency,
  };
}
